// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3VVJS","content":"LoadingAlert_content__mza6I"};